import * as React from "react"
import { cn } from "../../lib/utils"

const buttonVariants = {
  default: "ui-button ui-button-default",
  secondary: "ui-button ui-button-secondary",
  outline: "ui-button ui-button-outline",
  destructive: "ui-button ui-button-destructive",
  ghost: "ui-button ui-button-ghost",
}

const buttonSizes = {
  default: "ui-button-size-default",
  sm: "ui-button-size-sm",
  lg: "ui-button-size-lg",
  icon: "ui-button-size-icon",
}

const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", type = "button", ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(buttonVariants[variant], buttonSizes[size], className)}
        {...props}
      />
    )
  }
)

Button.displayName = "Button"

export { Button }
